export { default as AddAttachmentScreen } from "./AddImagesDocumentsScreen";
export { default as AttachmentAttachToContactScreen } from "./AttachToContact";
export { default as AttachmentAttachToTreatmentScreen } from "./AttachToTreatment";
export { default as AttachmentAttachToJournalScreen } from "./AttachToJournal";
export { default as AttachmentScreen } from "./ImagesDocumentsScreen";
